import { Component, Input } from '@angular/core'
import { FormControl } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { AppBasicEditorComponent } from '../../../../shared/components/app-basic-editor/app-basic-editor.component'
import { AppBasicSliderComponent } from '../../../../shared/components/app-basic-slider/app-basic-slider.component'
import { AppBasicCalendarComponent } from '../../../../shared/components/app-basic-calendar/app-basic-calendar.component'
import { AppBasicDropdownComponent } from '../../../../shared/components/app-basic-dropdown/app-basic-dropdown.component'
import { AppBasicInputComponent } from '../../../../shared/components/app-basic-input/app-basic-input.component'
import { CommonModule } from '@angular/common'

@Component({
   selector: 'ep-running-detail-tab',
   templateUrl: './ep-running-detail-tab.component.html',
   styleUrls: ['./ep-running-detail-tab.component.scss'],
   standalone: true,
   imports: [CommonModule,
      AppBasicInputComponent,
      AppBasicDropdownComponent,
      AppBasicCalendarComponent,
      AppBasicSliderComponent,
      AppBasicEditorComponent,
      TranslateModule]
})
export class EpRunningDetailTabComponent {
   @Input() acronymFC?: FormControl
   @Input() endDateFC?: FormControl
   @Input() foundingFC?: FormControl
   @Input() durationFC?: FormControl
   @Input() startDateFC?: FormControl
   @Input() typeOfActionFC?: FormControl
   @Input() currentMonthFC?: FormControl
   @Input() fundingAgreementIdFC?: FormControl
   @Input() callOfTheProposalFC?: FormControl
   @Input() generalObjectivesFC?: FormControl
   @Input() fundingAssociatedNameFC?: FormControl
   @Input() typeOfActionArray?: { id: string; name: string }[]

   getErrorMessage(control?: FormControl): string {
      if (!control) return ''
      if (control.hasError('min')) return 'error_input_minNumber'
      if (control.hasError('max')) return 'error_input_maxNumber'
      if (control.hasError('maxlength')) return 'error_input_maxLength'
      if (control.hasError('required')) return 'error_input_required'
      return ''
   }

   getLabelFromTypeOfActionId(id: string): string | undefined {
      return this.typeOfActionArray?.find((item) => item.id === id)?.name
   }
}
